export interface RecommendationResponse {
  recommendations: SliderRecommendations[];
}

export enum SliderRecommendationType {
  Default,
  ShipHurdle,
  BookCredit,
}
export interface SliderRecommendations {
  /** A unique identifier for this slider */
  identifier: string;

  type?: SliderRecommendationType;

  title: string | null;

  subtitle: string | null;

  bannerText: string | null;

  sliderClass: string | null;

  url: string | null;

  isHandPicked: boolean;

  idRecommendationCorrelation: string | null;
  guidUserRecommendation: string | null;
  shownRecommendationId: number | null;

  idModel: string | null;
  idRecommendationType: number | null;
  idSource: string | null;

  items: SliderRecommendationItem[];
}

export interface SliderRecommendationItem {
  idIQ: number | null;

  idWork: number;
  idAmazon: number | null;

  title: string;
  authors: string | null;
  synopsis: string | null;

  media: string | null;
  idMedia: number | null;

  quality: string | null;
  idQuality: number | null;

  imageUrl: string;
  url: string;

  price: number | null;

  idDefaultListItem: number | null;
}

/**
 * Converts a slider item to a Snowplow context
 * @param item The slider item
 * @param workIndex The index
 * @returns Returns an object to be passed into a context's data
 */
export function mapSliderItemToSnowplowContext(
  item: SliderRecommendationItem,
  workIndex: number,
) {
  return {
    id_work: item.idWork,
    price: item.price,
    idiq: item.idIQ,
    position_in_slider: workIndex,
  };
}

/**
 * Converts a slider to data to be passed into a Snowplow event
 * @param slider The slider to map
 * @param sliderPosition The position of the slider, starting at 0
 * @returns Returns an object to be passed into `trackSelfDescribingEvent`
 */
export function mapSliderToSnowplowData(
  slider: SliderRecommendations,
  sliderPosition: number,
) {
  const recommendationId =
    slider.guidUserRecommendation ?? slider.shownRecommendationId?.toString();

  return {
    id_recommendation_correlation: slider.idRecommendationCorrelation,
    id_recommendation: recommendationId,
    position: sliderPosition,
    content_format: "slider",
    content_type: "user_recommendation",
    id_model: slider.idModel,
    id_recommendation_type: slider.idRecommendationType ?? 0,
    id_source: slider.idSource
  };
}
